var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({attrs:{"type":"text"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.eventListeners))}
var staticRenderFns = []

export { render, staticRenderFns }